import React, { useEffect, useState, useContext } from 'react';
import moment from 'moment';
import { baseUrl } from '../utils/constants';

const ConstantsContext = React.createContext();

export const ConstantsProvider = (props) => {
  // const { myUser } = useUserContext();
  const group = Number(sessionStorage.getItem('province') ?? 20);
  const payCycleId = Number(sessionStorage.getItem('payCycleId'));
  const [employers, setEmployers] = useState([]);
  const [tierSchemes, setTierSchemes] = useState([]);
  const [bankBranches, setBankBranches] = useState([]);
  const [banks, setBanks] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [clientList, setClients] = useState([]);
  const [providerList, setProviderList] = useState([]);
  const [branches, setBranches] = useState([]);
  const [towns, setTowns] = useState([]);
  const [suburbs, setSuburbs] = useState([]);
  const [payCycles, setPayCycles] = useState([]);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    getActivePayCycles();
    console.log('Url at enter', baseUrl);
    getAllSuburbs();
    getAllCities();
    getBanks();
    getBankBranches();
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group]);

  const getMonthlyReport = async (begDate) => {
    fetch(`${baseUrl}/api/client/GetMonthlyStats?period=${moment(begDate).format('YYYY-MM-DD')}`)
      .then((result) => result.json())
      .then(
        (result) => {
          setChartData(result.result);
        },
        (error) => {
          console.log('error', error);
        }
      );
  };

  // const getDistrictStats = async (begDate) => {
  //   fetch(`${baseUrl}/api/client/getDistrictStats?period=${moment(begDate).format('YYYY-MM-DD')}`)
  //     .then((result) => result.json())
  //     .then(
  //       (result) => {
  //         setChartData(result.result);
  //       },
  //       (error) => {
  //         console.log('error', error);
  //       }
  //     );
  // };

  const getBanks = () => {
    fetch(`${baseUrl}/api/setting/getallbanks`)
      .then((res) => res.json())
      .then(
        (result) => {
          setBanks(result.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getBankBranches = () => {
    fetch(`${baseUrl}/api/setting/getAllBankBranches`)
      .then((res) => res.json())
      .then(
        (result) => {
          setBankBranches(result.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getProvinces = () => {
    fetch(`${baseUrl}/api/setting/getallprovinces`)
      .then((res) => res.json())
      .then(
        (data) => {
          setProvinces(data.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getBranches = () => {
    fetch(`${baseUrl}/api/client/getallbranches`)
      .then((res) => res.json())
      .then(
        (result) => {
          setBranches(result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getAllClients = () => {
    fetch(`${baseUrl}/api/client/getallClients`)
      .then((res) => res.json())
      .then(
        (list) => {
          setClients(list.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getAllCities = () => {
    fetch(`${baseUrl}/api/setting/getAllCities`)
      .then((res) => res.json())
      .then(
        (list) => {
          setTowns(list.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getAllSuburbs = () => {
    fetch(`${baseUrl}/api/setting/getallSuburbs`)
      .then((res) => res.json())
      .then(
        (list) => {
          setSuburbs(list.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getDistStats = async (payCycleId, group) => {
    fetch(`${baseUrl}/api/client/GetDistrictStats?payCycleId=${payCycleId}&province=${group}`)
      .then((result) => result.json())
      .then(
        (result) => {
          console.log('result.result dist stats', result.result);
          setChartData(result.result);
        },
        (error) => {
          console.log('error', error);
        }
      );
  };

  const getActivePayCycles = () => {
    fetch(`${baseUrl}/api/setting/getActivePayCycles`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned getActivePayCycles', result);
          setPayCycles(result);
          sessionStorage.setItem('currentMonth', moment(result[0].payDate).format('YYYY-MM-DD'));
          if (group > 0) {
            getDistStats(payCycleId, group);
          } else if (group === 0) {
            getMonthlyReport(moment(result[0].payDate).format('YYYY-MM-DD'));
          } else {
            getMonthlyReport('2010-01-01');
          }
        },
        (error) => {
          alert('failed');
        }
      );
  };

  return (
    <ConstantsContext.Provider
      value={{
        provinces,
        employers,
        tierSchemes,
        branches,
        banks,
        clientList,
        bankBranches,
        setClients,
        towns,
        suburbs,
        payCycles,
        providerList,
        setProviderList,
        chartData,
        getMonthlyReport,
        getDistStats
      }}
    >
      {props.children}
    </ConstantsContext.Provider>
  );
};

export const useConstantsContext = () => useContext(ConstantsContext);
